import React from "react";
import { createUseStyles } from "$utils/createUseStyles";
import { TablePaginationProps } from "@mui/material/TablePagination";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { theme } from "$utils/theme/bataillog";

type TablePaginationActionsProps = {
  count: number;
  page: number;
  rowsPerPage: number;
  onChangePage: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
  /* onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
  */
};

function TablePaginationActions(
  props: TablePaginationActionsProps & TablePaginationProps
) {
  const classes = useStyles();
  const { count, page, rowsPerPage, onChangePage } = props;
  let pageCount = count / rowsPerPage;

  if (!Number.isInteger(pageCount)) {
    pageCount = Math.floor(pageCount + 1);
  }

  const handleBackButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    onChangePage(event, page + 1);
  };

  const handlePageButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    newpage: number
  ) => {
    onChangePage(event, newpage);
  };

  // buttons pagination

  let buttons: any[];

  if (pageCount <= 7) {
    buttons = Array.from({ length: pageCount }).map((l, index) => index);
  } else if (page < 4) {
    buttons = [
      ...Array.from({ length: 5 }).map((l, index) => index),
      -1,
      pageCount - 1,
    ];
  } else if (page > pageCount - 5) {
    buttons = [
      0,
      -1,
      ...Array.from({ length: 5 }).map((l, index) => index + pageCount - 5),
    ];
  } else {
    buttons = [0, -1, page - 1, page, page + 1, -1, pageCount - 1];
  }

  return (
    <div className={classes.paginationFooter}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>

      {buttons.map((i, index) => {
        return i === -1 ? (
          <span key={`page-ellipsis-${i}-${index}`}>...</span>
        ) : (
          <Button
            key={`page-${i}-${index}`}
            onClick={(event) => handlePageButtonClick(event, i)}
            className={`${page !== i && "active"} page`}
          >
            <span
              style={{
                padding: `0 ${(i + 1).toString().length >= 3 ? 4 : 0}px`,
              }}
            >
              {i + 1}
            </span>
          </Button>
        );
      })}

      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
    </div>
  );
}

const useStyles = createUseStyles(() => ({
  paginationFooter: {
    display: "flex",
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
    textAlign: "right",
    "& button": {
      fontSize: 14,
      fontWeight: "bold",
      minWidth: 24,
      padding: 0,
      margin: "0 4px",
      "&-page": {
        padding: 0,
      },
      "&.active": {
        color: "#457DD9",
        background: "#457DD926 0% 0% no-repeat padding-box",
      },
      "&:hover": {
        color: "#457DD9",
        background: "#457DD926 0% 0% no-repeat padding-box",
      },
    },
  },
}));

export default TablePaginationActions;
